import React, { createContext } from 'react';
import { NEW_USER_REQUIREMENTS_VIEW_CONTEXT_INITIAL_VALUE } from './constants';

export const NewUserRequirementsViewContext = createContext(NEW_USER_REQUIREMENTS_VIEW_CONTEXT_INITIAL_VALUE);

export const NewUserRequirementsViewContextProvider = ({
    isMoreDetailsModalOpen,
    handleToggleMoreDetailsModal,
    isProcessAlreadyStartedModalOpen,
    handleToggleProcessAlreadyStartedModal,
    onClickStartProcess,
    children,
}) => (
    <NewUserRequirementsViewContext.Provider
        value={{
            isMoreDetailsModalOpen,
            handleToggleMoreDetailsModal,
            isProcessAlreadyStartedModalOpen,
            handleToggleProcessAlreadyStartedModal,
            onClickStartProcess,
        }}
    >
        {children}
    </NewUserRequirementsViewContext.Provider>
);
